import {
  Required,
  IsString,
  IsNumber,
  IsBoolean,
  IsArray,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import analytics from "@/utils/analytics";
import api from "./api";

interface ActorShowParams {
  condition1: "all" | "fav" | "my";
  condition2: {
    [key: string]: string[];
  };
  condition3: {
    order: "newly_added" | "name_desc" | "name_asc" | "use_count";
  };
  page: number;
  page_size: number;
}

interface ActorShowProps {
  condition: "all" | "fav" | "my";
  filters: {
    [key: string]: string[];
  };
  order: "newly_added" | "name_desc" | "name_asc" | "use_count";
  page: number;
  size: number;
}

interface ActorShowResponse {
  page_size: number;
  total: number;
  total_pages: number;
  current_page: number;
  actors: {
    id: string;
    model_id: string;
    name: string;
    gender: string;
    age_group: string;
    is_hd: boolean;
    is_pro: boolean;
    is_exclusive_pro: boolean;
    is_free_speech: boolean;
    situation: string;
    image_url: string;
    compressed_actor_default_video_url: string;
    full_actor_default_video_url: string;
    sort_order: number;
    is_favorite: boolean;
    is_my_actor: boolean;
    tags: string[];
    default_audio: {
      id: string;
      voice_tts_id: string;
      model_name: string;
      name: string;
      age_group: string;
      language: string;
      gender: string;
      emotion: string;
      speed: number;
      audio_url: string;
      duration: number;
      is_starred: boolean;
      is_selected: boolean;
      sort_order: number;
      use_count: number;
    };
  }[];
}

// 默认音频类
class DefaultAudio {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Voice TTS ID cannot be empty")
  @IsString("Voice TTS ID must be a string")
  voiceTtsId: string;

  @Required("Model name cannot be empty")
  @IsString("Model name must be a string")
  modelName: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Age group cannot be empty")
  @IsString("Age group must be a string")
  ageGroup: string;

  @Required("Language cannot be empty")
  @IsString("Language must be a string")
  language: string;

  @Required("Gender cannot be empty")
  @IsString("Gender must be a string")
  gender: string;

  // @Required("Emotion cannot be empty")
  // @IsString("Emotion must be a string")
  // emotion: string;

  @Required("Speed cannot be empty")
  @IsNumber("Speed must be a number")
  speed: number;

  @Required("Audio URL cannot be empty")
  @IsString("Audio URL must be a string")
  audioUrl: string;

  @Required("Is starred cannot be empty")
  @IsBoolean("Is starred must be a boolean")
  isStarred: boolean;
}

// 演员类
class Actor {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Model ID cannot be empty")
  @IsString("Model ID must be a string")
  modelId: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Gender cannot be empty")
  @IsString("Gender must be a string")
  gender: string;

  @Required("Age group cannot be empty")
  @IsString("Age group must be a string")
  ageGroup: string;

  @Required("Is HD cannot be empty")
  @IsBoolean("Is HD must be a boolean")
  isHd: boolean;

  @Required("Is pro cannot be empty")
  @IsBoolean("Is pro must be a boolean")
  isPro: boolean;

  @Required("Is exclusive pro cannot be empty")
  @IsBoolean("Is exclusive pro must be a boolean")
  isExclusivePro: boolean;

  @Required("Is free speech cannot be empty")
  @IsBoolean("Is free speech must be a boolean")
  isFreeSpeech: boolean;

  @Required("Situation cannot be empty")
  @IsString("Situation must be a string")
  situation: string;

  @Required("Image URL cannot be empty")
  @IsString("Image URL must be a string")
  imageUrl: string;

  @Required("Compressed actor default video URL cannot be empty")
  @IsString("Compressed actor default video URL must be a string")
  compressedActorDefaultVideoUrl: string;

  @Required("Full actor default video URL cannot be empty")
  @IsString("Full actor default video URL must be a string")
  fullActorDefaultVideoUrl: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;

  @Required("Is favorite cannot be empty")
  @IsBoolean("Is favorite must be a boolean")
  isFavorite: boolean;

  @Required("Is my actor cannot be empty")
  @IsBoolean("Is my actor must be a boolean")
  isMyActor: boolean;

  @Required("Tags cannot be empty")
  @IsArray("Tags must be an array")
  tags: string[];

  @IsNumber("Generate type must be a number")
  generateType: number;

  @Required("Default audio cannot be empty")
  @ValidateNested(DefaultAudio)
  defaultAudio: DefaultAudio;

  @IsString("Source must be a string")
  source: string;
}


class MyActor {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Model ID cannot be empty")
  @IsString("Model ID must be a string")
  modelId: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Gender cannot be empty")
  @IsString("Gender must be a string")
  gender: string;

  @Required("Age group cannot be empty")
  @IsString("Age group must be a string")
  ageGroup: string;

  @Required("Is HD cannot be empty")
  @IsBoolean("Is HD must be a boolean")
  isHd: boolean;

  @Required("Is pro cannot be empty")
  @IsBoolean("Is pro must be a boolean")
  isPro: boolean;

  @Required("Is exclusive pro cannot be empty")
  @IsBoolean("Is exclusive pro must be a boolean")
  isExclusivePro: boolean;

  @Required("Is free speech cannot be empty")
  @IsBoolean("Is free speech must be a boolean")
  isFreeSpeech: boolean;

  // @Required("Situation cannot be empty")
  // @IsString("Situation must be a string")
  // situation: string;

  @Required("Image URL cannot be empty")
  @IsString("Image URL must be a string")
  imageUrl: string;

  @Required("Compressed actor default video URL cannot be empty")
  @IsString("Compressed actor default video URL must be a string")
  compressedActorDefaultVideoUrl: string;

  @Required("Full actor default video URL cannot be empty")
  @IsString("Full actor default video URL must be a string")
  fullActorDefaultVideoUrl: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;

  @Required("Is favorite cannot be empty")
  @IsBoolean("Is favorite must be a boolean")
  isFavorite: boolean;

  @Required("Is my actor cannot be empty")
  @IsBoolean("Is my actor must be a boolean")
  isMyActor: boolean;

  @Required("Tags cannot be empty")
  @IsArray("Tags must be an array")
  tags: string[];

  @Required("Default audio cannot be empty")
  @ValidateNested(DefaultAudio)
  defaultAudio: DefaultAudio;

  @Required("Generate status cannot be empty")
  @IsNumber("Generate status must be a number")
  generateStatus: number;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  isUnusual?: boolean;
}

class MyActorProcess {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Generate status cannot be empty")
  @IsNumber("Generate status must be a number")
  generateStatus: number;
}

class MyActorFail {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Generate status cannot be empty")
  @IsNumber("Generate status must be a number")
  generateStatus: number;
}

// 主数据类
export class ActorShowData {
  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Total pages cannot be empty")
  @IsNumber("Total pages must be a number")
  totalPages: number;

  @Required("Current page cannot be empty")
  @IsNumber("Current page must be a number")
  currentPage: number;

  actors: Array<Actor & MyActor> | null;
}

const transformAndValidateActorShow = (
  response: ActorShowResponse
): ActorShowData => {
  const transformedData = transformKeys(response);
  try {
    const validatedData = DataValidator.validateOrThrow(transformedData, ActorShowData);
    if (!validatedData.actors) {
      return {
        ...validatedData,
        actors: [],
      };
    }
    if (!(validatedData.actors instanceof Array)) {
      throw new Error("Actors must be an array");
    }
    for (const actor of validatedData.actors) {
      const isMyActor = "generateStatus" in actor;
      if (isMyActor) {
        actor.isMyActor = true;
      }
      if (isMyActor && actor.generateStatus < 2) {
        try {
          DataValidator.validateOrThrow(actor, MyActorProcess);
        } catch (error) {
          console.error("My actor process data validation failed:", error.message);
          actor.isUnusual = true;
        }
      } else if (isMyActor && actor.generateStatus === 2) {
        try {
          DataValidator.validateOrThrow(actor, MyActor);
        } catch (error) {
          console.error("My actor data validation failed:", error.message);
          actor.isUnusual = true;
        }
      } else if (isMyActor && actor.generateStatus > 2) {
        try {
          DataValidator.validateOrThrow(actor, MyActorFail);
        } catch (error) {
          console.error("My actor fail data validation failed:", error.message);
          actor.isUnusual = true;
        }
      } else {
        DataValidator.validateOrThrow(actor, Actor);
      }
    }
    return validatedData;
  } catch (error) {
    analytics.trackModalMyActorFail({
      data_json: JSON.stringify(transformedData),
      error_message: error.message,
    });
    console.error("Actor show data validation failed:", error.message);
    throw error;
  }
};

const URL = "/actor/show";

// 获取演员信息
export const actorShow = async ({
  condition,
  filters,
  order,
  page,
  size,
}: ActorShowProps): Promise<ActorShowData> => {
  const params: ActorShowParams = {
    condition1: condition,
    condition2: filters,
    condition3: { order },
    page: page,
    page_size: size,
  };
  const response = await api.post<ActorShowResponse>(URL, params);
  const validatedData = transformAndValidateActorShow(response.data);
  return validatedData;
};
